<nav class="top-navbar">
    <h3 class="mb-0" translate>Notifications</h3>

    <sb-settings-menu
        [user]="commonDataService.user"
        [customerSettings]="commonDataService.customerSettings"
        [communityName]="commonDataService.community"
        [language]="commonDataService.language"
        (logout)="authenticationService.logOff({ isNeedToRevokeToken: true })">
    </sb-settings-menu>
</nav>

<div class="notifications-container content-block">
    <div class="d-flex h-100">
        <div class="me-2">
            <ul class="list-group">
                @for (type of notificationFilterList; track type) {
                    <li
                        class="list-group-item list-group-item-action filter-item"
                        [class.active]="notificationType === type"
                        (click)="onTabClick(type)">
                        <div class="list-group-item-title">
                            {{ type | notificationTypeName }}
                        </div>
                        @if (unreadNotificationsCounts[type]() > 0) {
                            <div class="badge tab-badge">{{ unreadNotificationsCounts[type]() }}</div>
                        }
                    </li>
                }
            </ul>
        </div>

        <div class="d-flex flex-column flex-fill">
            <div class="notification-buttons">
                <label class="switch-label mb-0 me-3">
                    <ui-switch [(ngModel)]="isShowUnread" (valueChange)="isShowUnread = $event"> </ui-switch>
                    <span translate>Show only unread</span>
                </label>
                <a (click)="notificationListComponent.markAllAsRead()" translate>Mark all as read</a>
            </div>

            <div class="notifications-scrolled-container" #scrolledContainer>
                <app-notification-list
                    [infiniteScrollContainerClass]="'.notifications-scrolled-container'"
                    [isShowUnread]="isShowUnread"
                    [notificationTypes]="notificationTypesToShow">
                </app-notification-list>
            </div>
        </div>
    </div>
</div>
